import { openBlock as t, createElementBlock as n, renderSlot as o } from "vue";
/* empty css                  */
import a from "../../_virtual/_plugin-vue_export-helper.js";
const s = { class: "ds-page-content" }, r = /* @__PURE__ */ Object.assign({
  name: "DsPageContent"
}, {
  __name: "page-content",
  setup(c) {
    return (e, p) => (t(), n("div", s, [
      o(e.$slots, "default", {}, void 0, !0)
    ]));
  }
}), i = /* @__PURE__ */ a(r, [["__scopeId", "data-v-0a1a5a68"]]);
export {
  i as default
};
